<template>
  <div class="search">
    <div class="width_100" id="Nav"></div>
    <div class="main_panel">
      <div class="navPage">
        <div id="PageLeft">
          <div class="Tit">
            <div class="word">搜索结果</div>
          </div>
          <div class="sort"></div>
        </div>
        <div id="PageRight">
          <div class="Nav">
            <i class="el-icon-house" style="font-size:16px;margin-right:10px"></i>
            <span> 您当前的位置： </span>
            <span>
              <router-link style="font-size:16px" to="/homePage">首页 <span></span></router-link>
            </span>搜索结果
          </div>
          <news-details ref="listDetail" :id="disid"></news-details>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { articles } from '@/api/common'
import newsDetails from '../../components/newsDetails/index.vue'
export default {
  components: {
    newsDetails
  },
  data() {
    return {
      isShowv: false,
      searchList:[],
      searchList1:[],
      searchList2:[],
      searchList3:[],
      pageSize: 15,
      pageNum: 1,
      total: 0,
      searchValue: '',
      isShowList:true,
      isShowDel:false,
      disid:'',
    }
  },
  computed: {},
  mounted() {
    this.disid= this.$route.params.id
    this.bannerImg()
  },
  methods: {
    articles() {
      var _this = this

      let data = {
        entTApplicationUuid: _this.webId,
        title: _this.searchValue,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.searchList = data.rows
          _this.total = data.totalRows
          _this.searchList1 = _this.searchList.slice(0,5)
          _this.searchList2 = _this.searchList.slice(5,10)
          _this.searchList3 = _this.searchList.slice(10,15)
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      var _this = this
      _this.pageNum = val
      _this.articles()
    },
    // 打开左右箭头
    openShow(){
      this.isShowv = true
    },
    closeShow(){
      this.isShowv = false
    },
  }
}
</script>

<style lang="scss">
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 22px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.1px;
  -moz-osx-font-smoothing: grayscale;
}
.search {
  width: 100%;
  height: auto;
  overflow: hidden;
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif;
  font-size: 14px;
}
// 轮播背景大图
.search .ziHead {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.search .ziHead .swiper-container {
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      text-align: center;
      position: relative;
      overflow: hidden;
      height: 540px;
    }
  }
}
.search .ziHead .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("../../assets/image/leftimg.png");
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}
.search .ziHead .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("../../assets/image/rightimg.png");
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}
.search .ziHead .swiper-button-prev {
  left: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}.search .ziHead .swiper-button-next {
  right: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}
.search .ziHead .swiper-button-prev.active {
  left: 10px;
}.search .ziHead .swiper-button-next.active {
  right: 10px;
}
.search .main_panel {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.navPage {
  display: block;
}

.search #Nav {
  position: absolute;
  height: 44px;
  z-index: -1;
  background-color: #f2f2f2;
}
.search #Nav {
  float: right;
  text-align: right;
  overflow: hidden;
  line-height: 40px;
  color: #636363;
  font-size: 14px;
}
.search .width_100 {
  width: 100% !important;
}
.search #PageLeft {
  width: 255px;
  float: left;
  overflow: hidden;
  margin-top: 3px;
  margin-right: 35px;
}
.search #PageLeft .Tit {
  width: 255px;
  height: 105px;
  color: #ffffff;
  z-index: 9999999;
  background: #0062b3 35px center no-repeat;
  margin-bottom: 2px;
}
.search #PageLeft .Tit .word {
  width: 155px;
  height: 105px;
  line-height: 105px;
  font-size: 26px;
  float: left;
  margin-left: 95px;
}
.search #PageLeft .sort {
  width: 100%;
  overflow: hidden;
}
.search #PageRight {
  width: 910px;
  // float: right;
  overflow: hidden;
  // margin-left: 35px;
}
.search #PageRight .Nav {
  width: 100%;
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  color: #888888;
  margin-bottom: 10px;
}
.search #PageRight .Nav a {
  color: #888888;
}
a,
a:focus,
a:hover {
  text-decoration: none;
}

.search .pagin {
  margin-top: 20px;
  margin-bottom: 40px;
}
.search .pagin .el-pagination {
  text-align: center;
}
.comUl {
  padding-left: 0px;
}
.comUl li {
  width: 100%;
  height: 38.4px;
  line-height: 38.4px;
  background: url(../../assets/image/li.jpg) left center no-repeat;
  text-indent: 1.2em;
}
.comUl li a {
  float: left;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  color: #000000;
  font-size: 15px;
}
.comUl li a:hover {
  animation: comUla 0.2s linear 1;
  color: #4d4d44d4;
}
@keyframes comUla {
  from {
    transform: translateY(+1px);
  }
  to {
    transform: translateY(+1px);
  }
}
.comUl li span {
  float: right;
  font-size: 15px;
}
.el-divider--horizontal{
  margin: 10px 0;
}
</style>
